
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { CalendarOutlined } from '@ant-design/icons';

import CalendarPicker from 'components/CalendarPicker';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import ErrorModal from 'components/Modal/ConfirmationModal';
import './styles.scss';
import { UPDATE_LEAD_LAST_CONTACTED } from '../../containers/Leads/types';

dayjs.extend(utc);

/**
 * @description: Last contacted date calendar component from leads index.
 * @param {*}
 * @return {*}
 */
export const LastContactedDropdown = ({ leadId, date, standardDate }) => {
  const dispatch = useDispatch();
  const [showCalendar, toggleCalendar] = useState(false);
  const [dateError, setDateError] = useState(false);

  const selectedDate = date ? dayjs(standardDate).format('MM/DD/YYYY') : dayjs().format();

  const show = () => {
    toggleCalendar(true);
  };

  const dismiss = () => {
    toggleCalendar(false);
  };

  const handleCalendarClick = (selectedCalendarDate) => {
    if (!selectedCalendarDate) return;
    const convertedDate = dayjs(selectedCalendarDate).utc().local().format();
    updateLastContacted(convertedDate);
  };

  const updateLastContacted = async (selectedCalendarDate) => {
    await dispatch({
      type: UPDATE_LEAD_LAST_CONTACTED,
      payload: {
        variables: {
          id: leadId,
          input: {
            lastContactedDate: selectedCalendarDate,
          },
        },
      },
    });
    dismiss();
  };

  const renderCalendar = () => {
    return (
      <CalendarPicker
        selected={selectedDate}
        showReminder={false}
        onDateChange={handleCalendarClick}
        hasClear={false}
      />
    );
  };

  const trigger = (
    <DropdownButton
      className="button--unstyled button--last-updated-calendar"
      isOpen={showCalendar}
      showIcon={date !== ''}
    >
      {date}
      {date === '' && (
        <span className={clsx('placeholder', { 'hover-expose': !showCalendar })}>
          <span className="icon-after">Select date</span>
          <CalendarOutlined
            style={{
              fontSize: '16px',
            }}
          />
        </span>
      )}
    </DropdownButton>
  );

  return (
    <>
      <APResponsiveDropdown
        opened={showCalendar}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
        placement="bottom-end"
        menuClass="options-menu--gray lead-data-dropdown"
      >
        <div onClick={(e) => e.stopPropagation()}>
          {renderCalendar()}
        </div>
      </APResponsiveDropdown>
      {dateError && (
        <ErrorModal
          visible={dateError}
          title="Last updated date couldn't be updated. Please try again."
          onClose={() => setDateError(false)}
          actions={(
            <button
              onClick={() => setDateError(false)}
              className="button"
            >
              Close
            </button>
          )}
        />
      )}
    </>
  );
};
